import { CalendarBookingDisplayItem, CalendarBookingInputItem, CustomFieldValueInputItem, EventCategoryNameDisplayItem, EventLocationNameDisplayItem, ParentSignupInputItem, PricePerParticipantUnit, StudentSignupInputItem, TagDisplayItem, TeacherCalendarDisplayItem } from '@sb/library/data-models';

export enum StudentSignupType {
    AdultStudent = "AdultStudent",
    ChildStudent = "ChildStudent",
}

export enum SignupSteps {
    Subjects = "Subjects",
    Teachers = "Teachers",
    Booking = 'Booking',
    Student = 'Student',
    Payment = 'Payment',
    Confirmation = 'Confirmation',
    ThankYou = 'ThankYou'
}

export enum BookingMode {
    Default = "Default",
    AlreadyBooked = "AlreadyBooked",
    ChooseNewSlot = "NewSlot",
    NoSlots = "NoSlots"
}

export enum SignupStudentMode {
    AdditionalStudent = "AdditionalStudent",
    Anonymous = "Anonymous"
}

export class SignupData {
    Mode!: SignupStudentMode;
    Student!: StudentSignupFrontendInputItem;
    Parent!: ParentSignupInputItem;

    constructor(initializer?: Partial<SignupData>) {
        if (initializer) {
            Object.assign(this, initializer);
        }
    }
}

export class CalendarBookingFrontendInputItem extends CalendarBookingInputItem {
    EventCategory: EventCategoryNameDisplayItem | null = null;
    EventLocation: EventLocationNameDisplayItem | null = null;
    Teacher: TeacherCalendarDisplayItem | null = null;
    EndDate: string = "1970-01-01T00:00:00";
    Mode: BookingMode = BookingMode.Default;
    HasFutureConflicts: boolean | null = null;
    PricePerParticipant: number = 0;
    PricePerParticipantUnit: PricePerParticipantUnit = PricePerParticipantUnit.PerEvent;
    SubjectTagID: string = '';
    EventPrice: number | undefined = undefined;
    TimezoneID: string | null = null;

    constructor(initializer?: Partial<CalendarBookingFrontendInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }
}

export class StudentSignupFrontendInputItem extends StudentSignupInputItem {
    override BookingRequest: CalendarBookingFrontendInputItem | null = null;
    Parent: ParentSignupInputItem | null = null;
    IsAdditionalStudent: boolean = false;
    constructor(initializer?: Partial<StudentSignupFrontendInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }
}

export interface PreFetchedSlots {
    SubjectTag?: TagDisplayItem;
    TeacherID?: string;
    Category?: string;
    BookingSlots: CalendarBookingDisplayItem[];
}
